import InstalmentScheduleModule from './InstalmentSchedule.module';

export * from './InstalmentScheduleModule.types';
export default InstalmentScheduleModule;
